import sysTaskList from './list.vue'
import sysTaskedit from './edit.vue'





let a = Object.assign({ sysTaskList,sysTaskedit})
export default a
